const STATUS_CONFIG = {
  ACTIVE: {
    label: "Active",
    className:
      "bg-emerald-50 text-emerald-700 ring-emerald-600/20"
  },

  INACTIVE: {
    label: "Inactive",
    className:
      "bg-slate-100 text-slate-600 ring-slate-500/20"
  },

  SUSPENDED: {
    label: "Suspended",
    className:
      "bg-red-50 text-red-700 ring-red-600/20"
  }
};

const UserStatusBadge = ({
  status
}) => {
  const config =
    STATUS_CONFIG[status] ||
    STATUS_CONFIG.INACTIVE;

  return (
    <span
      className={`
        inline-flex
        items-center
        gap-1.5
        rounded-full
        px-2.5
        py-1
        text-xs
        font-medium
        ring-1
        ring-inset
        ${config.className}
      `}
    >
      <span
        className="h-1.5 w-1.5 rounded-full bg-current"
        aria-hidden="true"
      />

      {config.label}
    </span>
  );
};

export default UserStatusBadge;